import Vue from 'vue'
import Router from 'vue-router'
let Games = (resolve) => { return import('@/components/games/') }
let List = (resolve) => { return import('@/components/list/') }
let Recently = (resolve) => { return import('@/components/recently/') }
let Pdf = (resolve) => { return import('@/components/pdf/') }

let GameScoreList = (resolve) => { return import('@/components/gameScoreList/') }
let AllTotalPoints = (resolve) => { return import('@/components/allTotalPoints/') }
let CompetitionEvents = (resolve) => { return import('@/components/CompetitionEvents/') }
let UnitNameChn = (resolve) => { return import('@/components/unitNameChn/') }
let CorporationProjects = (resolve) => { return import('@/components/unitNameChn/CorporationProjects') }
let login = (resolve) => { return import('@/components/login') }
let relay = (resolve) => { return import('@/components/relay') }
Vue.use(Router)
const vueRouter = new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: List
    },
    {
      path: '/list',
      name: 'list',
      component: List,
      meta: {
        title: '运动会列表信息'
      }
    },
    {
      path: '/recently',
      name: 'recently',
      component: Recently,
      meta: {
        title: '近期赛事'
      }
    },
    {
      path: '/games',
      name: 'games',
      component: Games,
      meta: {
        title: '运动会日程'
      }
    },
    {
      path: '/gameScoreList',
      name: 'gameScoreList',
      component: GameScoreList,
      meta: {
        title: '运动会成绩列表'
      }
    },
    {
      path: '/AllTotalPoints',
      name: 'AllTotalPoints',
      component: AllTotalPoints,
      meta: {
        title: '全能比赛总成绩'
      }
    },
    {
      path: '/CompetitionEvents',
      name: 'CompetitionEvents',
      component: CompetitionEvents,
      meta: {
        title: '运动员参赛的项目'
      }
    },
    {
      path: '/UnitNameChn',
      name: 'UnitNameChn',
      component: UnitNameChn,
      meta: {
        title: '参赛单位列表'
      }
    },
    {
      path: '/CorporationProjects',
      name: 'CorporationProjects',
      component: CorporationProjects,
      meta: {
        title: '单位所有运动员'
      }
    },
    {
      path: '/Pdf',
      name: 'Pdf',
      component: Pdf,
      meta: {
        title: '单位所有运动员'
      }
    },
    {
      path: '*',
      component: List
    },
    {
      path: '/login',
      name: 'login',
      component: login,
      meta: { 
        title: '登录'
      }
    }, {
      path: '/relay',
      name: 'relay',
      component:relay,
      meta: {
        title: '录入棒次表'
      }
    }
  ]
})

vueRouter.afterEach((to, from) => {
  // 进入路由更改页面title标题
  if (to.meta.title) {
    window.document.title = to.meta.title
  } else {
    window.document.title = '运动会列表信息'
  }
})

export default vueRouter



// WEBPACK FOOTER //
// ./src/router/index.js